<div class="ds-form-control__wrapper">
    <ng-container *ngIf="label">
        <label class="ds-form-control__label" [for]="id">{{ label }}</label>
    </ng-container>

    <mat-form-field
        class="ds-form-control__item ds-select"
        appearance="outline"
        subscriptSizing="dynamic"
        [class.ds-select--has-clear]="isClearable && hasSelection && !disabled"
    >
        <mat-select
            [id]="id"
            [attr.aria-label]="ariaLabel"
            [attr.aria-labelledby]="ariaLabelledby"
            [compareWith]="compareWith ?? defaultCompareWith"
            [disabled]="disabled"
            [formControl]="control"
            [panelClass]="panelClass"
            [placeholder]="placeholder"
            (selectionChange)="selectionChange.emit($event)"
        >
            <ng-template [ngIf]="showSearch">
                <mat-option class="interactive-option search-option" disabled>
                    <ds-input #searchInput placeholder="Search" [formControl]="autocompleteControl" (keydown)="onSearchKeydown($event)">
                        <span prefix>
                            <mat-icon>search</mat-icon>
                        </span>
                    </ds-input>
                </mat-option>
            </ng-template>

            <ng-container *ngIf="hasOptionsInput; else projectedOptions">
                <mat-option *ngFor="let option of visibleOptions; trackBy: trackByOptionId" [value]="option">
                    {{ option.name }}
                </mat-option>
            </ng-container>

            <ng-template #projectedOptions>
                <ng-content></ng-content>
            </ng-template>

            <ng-container *ngIf="noOptionsAvailable">
                <mat-option class="interactive-option filter-text-option" disabled>No options available.</mat-option>
            </ng-container>

            <ng-container *ngIf="noOptionsMatchingFilter">
                <mat-option class="interactive-option filter-text-option" disabled>No options matching your filter.</mat-option>
            </ng-container>
        </mat-select>

        <span matPrefix>
            <ng-content matPrefix select="[prefix]"></ng-content>
        </span>

        <span matSuffix>
            <mat-icon
                *ngIf="isClearable && hasSelection && !disabled"
                class="ds-select__clear"
                fontSet="material-symbols-rounded"
                (click)="onClearSelection($event)"
                >close</mat-icon
            >
            <ng-content select="[suffix]"></ng-content>
        </span>

        <mat-error>
            <ng-content select="mat-error"></ng-content>
        </mat-error>

        <mat-hint>
            <ng-content select="mat-hint"></ng-content>
        </mat-hint>
    </mat-form-field>
</div>
